import requestApi from "../../../api/fetchApi";
import { CreateOrUpdateNodeInterface, NodeInterface } from "../schemas/nodes";


export async function getProjectNodes(projectId: string | number): Promise<NodeInterface[]> {
    return requestApi.GET(`/api/projects/${projectId}/nodes`);
}


export async function createProjectNode(projectId: string | number, node: CreateOrUpdateNodeInterface): Promise<NodeInterface> {
    return requestApi.POST(`/api/projects/${projectId}/nodes`, {body: node});
}


export async function updateProjectNode(projectId: string | number, node: CreateOrUpdateNodeInterface): Promise<NodeInterface> {
    return requestApi.PUT(`/api/projects/${projectId}/nodes`, {body: node});
}

export async function deleteProjectNode(projectId: string | number, nodeId: number | string): Promise<void> {
    return requestApi.DELETE(`/api/projects/${projectId}/nodes/${nodeId}`);
}
